export { default as authReducers } from 'auth/reducers/auth_reducers';



// WEBPACK FOOTER //
// src/modules/auth/reducers/index.js